import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPlaceService } from '../store/slices/placeServiceSlice';
import { AppState } from '../store/store';
import get from 'lodash/get';

export const usePlaceService = () => {
  const dispatch = useDispatch();
  const { findAll } = useSelector((state: AppState) => state.placeService);

  useEffect(() => {
    dispatch(fetchPlaceService({ limit: 1000 }));
  }, []);

  return {
    items: get(findAll, 'payload.items', [])
  };
};
